import { useNavigate } from "react-router-dom";
import PlanCard from "../pages/prestataires/planCard";
import { useEffect, useState } from "react";
import { get } from "../services/services";

const Formules = () => {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    get("subscriptions")
      .then((res) => {
        setPlans(res?.data);
      })
      .catch((err) => {
        // console.log(err);
      });
  }, []);

  return (
    <>
      <div className="row mt-40">
        {/* Free Plan Column */}
        <div className="col-md-3  padding-8 d-flex flex-column">
          
          <div className="card-border h-100 ">
            <div className="card-padding">
              <h4 className="card-title mb-24">Plan liberté</h4>
              <h2 className="card-price">0€</h2>
              <p className="col card-text">
                Seulement 3% de commission par rendez-vous
              </p>
              <div className="d-flex mt-24">
                <img src="/images/check-01.svg" alt="check icon" />{" "}
                <span className="text-body-card">Sans engagement</span>
              </div>
              <div className="d-flex">
                <img src="/images/check-01.svg" alt="check icon" />{" "}
                <span className="text-body-card">Accès illimité</span>
              </div>
              <div className="d-flex">
                <img src="/images/check-01.svg" alt="check icon" />{" "}
                <span className="text-body-card">Frais de gestion compris</span>
              </div>
            </div>
            <button
              type="button"
              className="twyny-cta-secondary card-button"
              onClick={() => {
                navigate(`/registerPrestataire`, { state: { plan: "libre" } });
              }}
            >
              Commencer gratuitement
            </button>
          </div>
          
          {/* Small merchant box - visible only on mobile */}
          <div className="box-white p-16 d-md-none">
            <p className="body text-center bold600 grey500">
              Vous êtes un petit commerçant ?
            </p>
            <p className="body grey66 text-center">
              Profitez du sans engagement et ne payez que sur vos rendez-vous
            </p>
          </div>
        </div>

        {/* Paid Plans */}
        <div className="col-md-9 d-flex flex-column">
          <div className="row">
            {plans.map((plan) => (
              <PlanCard plan={plan} from="landingPage"/>
            ))} 
          </div>
          
          {/* Regular appointments box - visible only on mobile */}
          <div className="row d-md-none">
            <div className="col">
              <div className="text-center box-white p-16">
                <div className="w-50 mx-auto">
                  <p className="body bold600 grey500 text-center">
                    Vous avez régulièrement des rendez-vous ?
                  </p>
                  <p className="body grey66 text-center">
                    Optez pour nos tarifs mensuels et profitez de rendez-vous
                    illimités sans frais !
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Desktop-only boxes */}
      <div className="row d-none d-md-flex">
        <div className="col-md-3  padding-8 d-flex flex-column">
          <div className="box-white p-16">
            <p className="body text-center bold600 grey500">
              Vous êtes un petit commerçant ?
            </p>
            <p className="body grey66 text-center">
              Profitez du sans engagement et ne payez que sur vos rendez-vous
            </p>
          </div>
        </div>
        
        <div className="col-md-9  padding-8 d-flex flex-column">
          <div className="text-center box-white  align-content-center p-16">
            <div className="w-50 mx-auto">
              <p className="body bold600 grey500 text-center">
                Vous avez régulièrement des rendez-vous ?
              </p>
              <p className="body grey66 text-center">
                Optez pour nos tarifs mensuels et profitez de rendez-vous
                illimités sans frais !
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Formules;